import { render } from "./ContractModelShow.vue?vue&type=template&id=2c069e52&scoped=true"
import script from "./ContractModelShow.vue?vue&type=script&lang=js"
export * from "./ContractModelShow.vue?vue&type=script&lang=js"

import "./ContractModelShow.vue?vue&type=style&index=0&id=2c069e52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c069e52"]])

export default __exports__